import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import withMe, { MePropsType } from '../../hocs/withMe.tsx';
import { UserRoles, PlatformTypes } from '../../constants/entities.ts';
import { Children } from '../../constants/types/prop.types.ts';
import Routes from '../routes.enum.ts';

type Props = MePropsType & Children & {
  redirect?: Routes;
};

const AdminGuard: FC<Props> = ({
  user: { role, platform },
  redirect = Routes.AdminSignIn,
  children,
}) => {
  // Check if user has Admin role
  if (role !== UserRoles.Admin) {
    return <Navigate to={redirect} replace />;
  }

  // If platform exists, it should be ADMIN
  // If platform doesn't exist, allow access for Admin role (backward compatibility)
  if (platform && platform !== PlatformTypes.Admin) {
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default withMe(AdminGuard);
